<template>
<div class="modal fade" id="infModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">INFORMATIONS FINANCIERES</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"  aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <form  @submit.prevent="submit" method="post">
                        <div class="form-group">
                            <ckeditor :editor="editor" v-model="text" :config="editorConfig"></ckeditor>
                        </div>

                       <div class="form-group">
                            <label for="">BILAN (fichier excel)</label>
                            <input type="file" class="form-control" name="file" id="file" @change="bilanChange">
                       </div>
                       <div class="form-group">
                            <label for="">COMPTE DE RESULTAT (fichier excel)</label>
                            <input type="file" class="form-control" name="file" id="file" @change="resultatChange">
                       </div>
                       <div class="form-group">
                            <label for="">FLUX DE TRESORERIE (fichier excel)</label>
                            <input type="file" class="form-control" name="file" id="file" @change="tresoChange">
                       </div>
                       <div class="form-group">
                         <button class="btn btn-success" data-bs-dismiss="modal" type="submit"><i class="bx bi-save"></i> ENREGISTRER</button>
                       </div>
                </form>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import axios from "axios";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    export default{
        name:'InfoFinComponent',
        props:{
            dossier:{
                'type':Object,
                'required':true,
            }
        },
        data(){
            return {
                text:'',
                bilan:null,
                resultat:null,
                treso:null,
                editor: ClassicEditor,
                editorConfig: this.editorConfig,

            }
        },
        methods:{
            bilanChange(event){
                this.bilan = event.target.files[0];
            },
            resultatChange(event){
                this.resultat = event.target.files[0];
            },
            tresoChange(event){
                this.treso = event.target.files[0];
            },
            submit(){
                    let loader = this.$loading.show({
                        container: this.fullPage ? null : this.$refs.formContainer,
                        canCancel: false,
                    });
                    let form = new FormData();
                    if(this.bilan!=null){
                        form.append("bilan",this.bilan);
                    }
                    if(this.resultat!=null){
                        form.append("resultat",this.resultat);
                    }
                    if(this.treso!=null){
                        form.append("treso",this.treso);
                    }
                    form.append("text",this.text);
                    form.append("id",this.dossier.id);
                    axios.post(this.path+'supplier/dossier/info_fin',form,{
                        headers:{
                            'Accept':'multipart/form-data'
                        }
                    })
                    .then((res)=>{
                        console.log(res)
                        this.$emit('success');
                    })
                    .catch((err)=>{
                        this.$emit('error')
                        //this.toaster.error("Une erreur est survenue lors de l'enregistrement !");
                        console.log(err)
                    })
                    .finally(()=>loader.hide())
                
            }
        },
        computed:{
        },
        watch:{
            dossier(newValue,oldValue){
                console.log(oldValue)
                console.log(newValue)
                this.text = this.dossier.plan_utilisation_text;
            }
        },
        mounted(){
            this.text = this.dossier.plan_utilisation_text;
        }
    }

</script>

<style scoped>


</style>